import React from "react";

const UserFavoriteProductsPage: React.FC = () => {
  return <div>UserFavoriteProductsPage</div>;
};

export default UserFavoriteProductsPage;
